<template>
	<div class="content">
		<headerTop></headerTop>
		<div class="swiperImg" :style="{backgroundImage:'url('+$index.addurl(img)+')'}"></div>
		<div class="center page-content flexbetween" :style="{animation:animation}">
			<div class="right">
				<div class="child" v-html="contents"> </div>
			</div>
		</div>
	</div>
</template>

<script>
	import router from "../../router";
	import headerTop from '../../components/headerTop.vue'
	export default {
		components: {
			headerTop
		},
		data() {
			return {
				value: false, //分页只有一页时隐藏分页
				currentPage: 1, //分页当前页数
				id: 0,
				contents: '',
				img: '',
				animation: '',
			}
		},
		created() {
			this.animation = 'detail .4s linear forwards'
			this.getdata();
		},
		methods: {
			todetail(id) {
				if (id == 1) {
					this.$router.push({
						name: 'bgHuanjing',
						query: {
							id: id
						}
					})
				} else if (id == 2) {
					this.$router.push({
						name: 'rzLiucheng',
						query: {
							id: id
						}
					})
				} else if (id == 3) {
					this.$router.push({
						name: 'mtGuantui',
						query: {
							id: id
						}
					})
				} else if (id == 4) {
					this.$router.push({
						name: 'jjZhuce',
						query: {
							id: id
						}
					})
				} else if (id == 5) {
					this.$router.push({
						name: 'fwAnli',
						query: {
							id: id
						}
					})
				}
			},
			getdata() {
				let id = this.$route.query.id;
				let type = this.$route.query.type;
				let _this = this;
				if (type == 0) {
					_this.$api.user.getTrendsSquareInfo({
						id: id,
					}).then(res => {
						if (res.code == 1) {
							_this.contents = res.data.content;
							_this.img = res.data.background_img;
						}
					})
				} else {
					_this.$api.user.getTrendsMechanismInfo({
						id: id,
					}).then(res => {
						if (res.code == 1) {
							_this.contents = res.data.content;
							_this.img = res.data.background_img;
						}
					})
				}
			},
		},

	}
</script>
<style scoped>
	.content {
		background-color: #1452DC;
		border-bottom: 1px solid #1452DC;
		/* overflow: hidden; */
	}
</style>
<style scoped lang="scss">
	.right {
		width: 100%;

		.child {
			width: fit-content;
			margin: 0 auto;
		}
	}

	.swiperImg {
		background-image: url('../../assets/page4/bg1.png');
		background-size: cover;
		background-position: center;
		position: relative;
		padding: 250px 0;

		.lTitle {
			margin-left: 4vw;
			font-size: 30px;
			letter-spacing: 4px;
			color: #fff;
		}

		.bTitle {
			margin-left: 4vw;
			color: #fff;
			font-size: 58px;
			letter-spacing: 4px;
			font-weight: bold;
		}

		.sTitle {
			margin-left: 4vw;
			letter-spacing: 2px;
			font-size: 14px;
			color: #fff;
		}
	}

	.center {
		min-height: 300px;
		margin: 0 auto 100px;
		background-color: #fff;
		// padding: 70px 190px;
		padding: 80px 120px;
		border-radius: 30px;
		position: relative;
		top: -80px;
	}
</style>


// WEBPACK FOOTER //
// squaredetail.vue?0547f906